import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: false,
})
export class FooterComponent {
  public currentYear = new Date().getFullYear();
  public socialMediaLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61568176071078',
    instagram: 'https://www.instagram.com/institutwissen/',
    linkedin: 'https://www.linkedin.com/company/institut-wissen/about/',
  };
}
